import { Box, Grid } from '@mui/material'
import ReceiveLab from 'features/lab-order/component/ReceiveLab'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

/** API */
import LabOrderApi, { LabOrderListInterface } from 'api/lab-order.api'

/** COMPONENT */
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import TableCustom, { TablePaginationMiniCustom } from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import ViewLabOrder from 'features/lab-order/component/ViewLabOrder'

/** STYLE */
import { colors } from 'constants/theme'
import * as UseStyled from 'features/lab-order/lab-order-style'

/** UTILS & CONSTANT */
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import VisibilityIcon from '@mui/icons-material/Visibility'
import ClinicApi from 'api/master/clinic.api'
import LabCompanyApi from 'api/setting/default-labs/lab-company.api'
import { expired } from 'app/slice/expired.slice'
import { handleShow, resetModal, showModal } from 'app/slice/modal.slice'
import { swalDelete } from 'component/Alert/Swal'
import Loading from 'component/Loading'
import PDFLabOrder from 'component/Pdf/PDFLabOrder'
import FunctionPrint from 'component/Print/print'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { icons } from 'constants/images'
import CancelLabOrder from 'features/lab-order/component/CancelLabOrder'
import FormLabOrder from 'features/lab-order/component/FormLabOrder'
import IconDropdownButton from 'new-components/buttons/icon-dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import DropdownItem from 'react-bootstrap/esm/DropdownItem'
import { routeName } from 'routes/routes-name'
import { numberToCurrencyFormat } from 'utils/app.utils'
import { dateTimeToView, dateToView } from 'utils/date.utils'
import { UseSnCode } from 'utils/useSnCode'
import UseWindowSize from 'utils/useWindowSize'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'
import RejectLabOrder from './component/RejectLabOrder'

const arrayLabOrderStatus: string[] = ['ORDER_LAB', 'SEND_LAB', 'RECEIVE_LAB', 'REPLY_LAB', 'RECEIVE_BILL', 'CANCEL_LAB', 'CLOSE_LAB',]// 'REPLY_LAB'
export interface ILabOrderListProps {
    date?: string
    valReload: any
    reload: () => void
    reloadQueue?: (va: boolean) => void
}
export default function LabOrderList(props: ILabOrderListProps) {
    const { t } = useTranslation()
    const modal = useSelector(handleShow)
    const history = useHistory()
    const dispatch = useDispatch()
    const expire = useSelector(expired)
    const [width] = UseWindowSize()
    const [loading, setLoading] = useState<boolean>(false)
    const permissions = { isCreate: isCreate(), isDelete: isDelete(), isUpdate: isUpdate(), isView: isView() }

    const [isViewDetail, setIsViewDetail] = useState<boolean>(false)
    const [isForm, setIsForm] = useState<boolean>(false)
    const [popupCancel, setPopupCancel] = useState<boolean>(false)
    const [popupReject, setPopupReject] = useState<boolean>(false)
    const [labOrderId, setLabOrderId] = useState<number>(0)
    const [labOrderNumber, setLabOrderNumber] = useState<string>('')
    const [labOrderStatus, setLabOrderStatus] = useState('')
    const [patientId, setPatientId] = useState(0)

    /** FILTER */
    const [filterSearch, setFilterSearch] = useState<string>('')
    const [filterRangeDate, setFilterRangeDate] = useState<string[]>(emptyRangePicker)
    const [filterLabCompany, setFilterLabCompany] = useState<number>(0)
    const [filterLabOrderStatus, setFilterLabOrderStatus] = useState<string>('ALL')
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('dateOrder')
    const [sortType, setSortType] = useState('DESC')
    const [doctorOptions, setDoctorOptions] = useState<any[]>([])
    const [filterDoctorId, setFilterDoctorId] = useState<number>(0)

    /** OPTION */
    const [labCompanyOptions, setLabCompanyOptions] = useState<any[]>([])

    /** DATA */
    const [labOrders, setLabOrders] = useState<any[]>([])
    const [popupReceive, setPopupReceive] = useState<boolean>(false)
    const [dateReceive, setDateReceive] = useState<string | null>(null)

    const [snType, setSnType] = useState(false);

    const [pdfLabOrder, setPdfLabOrder] = useState<boolean>(false)
    const [pdfDataLabOrder, setPdfDataLabOrder] = useState<any>({})
    const pdfLabOrderRef = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (width > 0) {
            setPageLimit(width > 1440 ? 10 : 3)
        }
    }, [width])

    const handleSnCode = useCallback(() => {
        const fetchData = async () => {
            const sn = await UseSnCode();
            setSnType(sn);
        };

        fetchData();

    }, [snType]);

    useEffect(() => {
        handleSnCode()
    }, []);

    const loadData = useCallback(async () => {
        setLoading(true)
        let condition: any = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (filterSearch) condition = { ...condition, search: filterSearch }
        if (filterLabCompany) condition = { ...condition, labCompanyId: filterLabCompany }
        if (filterLabOrderStatus && filterLabOrderStatus !== 'ALL') condition = { ...condition, labOrderStatus: filterLabOrderStatus }
        if (filterRangeDate) {
            if ((filterRangeDate[0] !== null || filterRangeDate[0] !== '') && (filterRangeDate[1] !== null || filterRangeDate[1] !== ''))
                condition = { ...condition, dateStart: filterRangeDate[0], dateEnd: filterRangeDate[1] }
        }
        if (filterDoctorId) {
            condition = { ...condition, doctorId: filterDoctorId }
        }


        const patients = await LabOrderApi.findAll(condition).finally(() => setLoading(false))
        if (patients.status === 200) {
            setLabOrders(patients.data)
            setRowCount(patients.headers['x-total'])
        }
        //   props.reload()
        setLabOrderId(0)
        setIsForm(false)
        setPopupCancel(false)
    }, [props.valReload, page, pageLimit, sortBy, sortType, filterSearch, filterRangeDate, filterLabCompany, filterLabOrderStatus, filterDoctorId])

    const loadOptions = async () => {
        const condition: any = { page: 1, pageLimit: 999, status: 'ACTIVE' }
        await LabCompanyApi.findAll(condition).then(({ data }) => {
            setLabCompanyOptions(data)
        })
        await ClinicApi.findAllDoctors().then(({ data }) => {
            setDoctorOptions(data)
        })
    }

    useEffect(() => {
        loadData()
    }, [loadData])

    useEffect(() => { loadOptions() }, [])

    const onView = (e: any, objVal: LabOrderListInterface) => {
        setLabOrderId(objVal.labOrderId)
        setIsViewDetail(true)
        dispatch(showModal())
    }

    const onClose = () => {
        setLabOrderId(0)
        setIsViewDetail(false)

    }

    const onCreate = () => {
        setIsForm(true)
        dispatch(showModal())
    }

    const onEdit = (objData: LabOrderListInterface) => {
        const { labOrderId: id } = objData
        setLabOrderId(id)
        dispatch(showModal())
        setIsForm(true)
    }

    const onDelete = (objData: LabOrderListInterface) => {
        const { labOrderId: id, labOrderNumber: labOrderNum } = objData
        swalDelete(
            `<p class="mb-0 mx-auto" style="max-width: 325px">${t('LAB_ORDER.ALERT.CONFIRM_DELETE')} ${t('LAB_ORDER.MESSAGE.YESNO')}</p>`,
            `<p class="text-center mb-0 mx-auto" style="max-width: 306px">${t('LAB_ORDER.MESSAGE.DEL_SUB')} ${labOrderNum} <br /> ${t('LAB_ORDER.MESSAGE.YESNO')}</p>`,
            (res: any) => {
                if (res) {
                    LabOrderApi.remove(id)
                        .then((resp) => (notiSuccess(t('LAB_ORDER.MESSAGE.SUCCESS.DELETE'), '', null, () => {
                            loadData();
                            props.reload();
                        }))).catch((e) => (notiError(t('LAB_ORDER.MESSAGE.ERROR'))))
                }
            },
            { confirmButtonText: t('LAB_ORDER.ALERT.BTN_CONFIRM_DELETE'), width: '450px', cancelButtonText: t('BUTTON.CANCEL') }
        )
    }

    const onCancel = (objData: LabOrderListInterface) => {
        const { labOrderId: id, labOrderNumber: lbNo } = objData
        setLabOrderId(id)
        setLabOrderNumber(lbNo)
        dispatch(showModal())
        setPopupCancel(true)
    }

    const onReject = (objData: LabOrderListInterface) => {
        const { labOrderId: id, labOrderNumber: lbNo, labOrderStatus, userId, patientId, labCompanyId, labGroupId } = objData
        setLabOrderId(id)
        setLabOrderNumber(lbNo)
        setLabOrderStatus(getLabelLabOrderStatus(labOrderStatus) || '-')
        setPatientId(patientId)
        setPopupReceive(false)
        dispatch(showModal())
        setPopupReject(true)
    }

    const reset = async (objData: LabOrderListInterface) => {
        const { labOrderId: id } = objData
        await LabOrderApi.reset(id).then((res) => {
            if (res.status === 200) {
                notiSuccess(t('...'), '', null, null)
                loadData()
                props.reload()
            }
        })
    }

    const onReset = () => {
        setLabOrderId(0)
        setIsForm(false)
        setPopupCancel(false)
        setDateReceive(null)
        setPopupReceive(false)
        setPopupReject(false)
        dispatch(resetModal())
    }

    const onViewHistory = (objData: LabOrderListInterface) => {
        history.push(routeName.labOrder + '/view-history', objData)
    }

    const onPrintLabDoc = async (valueLabOrderId: number) => {
        setLoading(true)
        const receipt = await LabOrderApi.printLabDocument(valueLabOrderId)

        if (receipt?.status === 200) {
            setPdfDataLabOrder(receipt.data)
            setTimeout(() => {
                buttonRef.current?.click()
                setLoading(false)
            }, 0)
            return
        }

        setLoading(false)
        // if (receipt && receipt.status === 200) return window.open(`${fileUrl}/${receipt.data}`, '_blank')
    }

    const desktopHeadCells = [
        { id: 'no', disablePadding: false, label: t('#'), class: 'text-nowrap' },
        { id: 'dateOrder', disablePadding: false, label: t('LAB_ORDER.TABLE.DATE_TIME_ORDER'), class: 'text-nowrap' },
        { id: 'labOrderNumber', disablePadding: false, label: t('LAB_ORDER.TABLE.LAB_ORDER_NUMBER'), class: 'text-nowrap' },
        { id: 'labCompanyName', disablePadding: false, label: t('LAB_ORDER.TABLE.COMPANY'), class: 'text-nowrap' },
        { id: 'dateExport', disablePadding: false, label: t('LAB_ORDER.TABLE.DATE_EXPORT'), class: 'text-nowrap' },
        { id: 'dateReceive', disablePadding: false, label: t('LAB_ORDER.TABLE.DATE_RECEIVE'), class: 'text-nowrap' },
        { id: 'message', disablePadding: false, label: t('APPLICATION.TABLE.CELL.CN_NUMBER'), class: 'text-nowrap' },
        { id: 'branchId', disablePadding: false, label: t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID'), class: 'text-nowrap' },
        { id: 'branchId', disablePadding: false, label: t('PATIENT_MANAGEMENT.TABLE.CELL.SN_CODE'), class: 'text-nowrap' },
        { id: 'patientFullName', disablePadding: false, label: t('LAB_ORDER.TABLE.PATIENT_NAME'), class: 'text-nowrap' },
        { id: 'doctorFullName', disablePadding: false, label: t('LAB_ORDER.TABLE.DOCTOR_NAME'), class: 'text-nowrap' },
        { id: 'labOrderStatus', disablePadding: false, label: t('LAB_ORDER.TABLE.STATUS'), class: 'text-nowrap' },
        { id: 'dateBill', disablePadding: false, label: t('LAB_ORDER.TABLE.DATE_BILL'), class: 'text-nowrap' },
        { id: 'labOrderPrice', disablePadding: false, label: t('LAB_ORDER.TABLE.PRICE'), class: 'text-nowrap' },
        { id: 'staffBy', disablePadding: false, label: t('LAB_ORDER.TABLE.SAVED_BY'), class: 'text-nowrap' },
    ]
    if (!snType) {
        desktopHeadCells.splice(8, 1)
    }
    const tableHeadCells = [
        { id: 'action', disablePadding: false, label: t('LAB_ORDER.TABLE.ACTION'), class: 'text-nowrap' },
    ]

    const headCells = width >= 1200 ? [...desktopHeadCells, ...tableHeadCells] : [...tableHeadCells]

    const getLabelLabOrderStatus = (status: string) => {
        let label: any = ''
        if (status === 'ORDER_LAB') label = t('LAB_ORDER.LAB_STATUS.ORDER_LAB')
        else if (status === 'SEND_LAB') label = t('LAB_ORDER.LAB_STATUS.SEND_LAB')
        else if (status === 'RECEIVE_LAB') label = t('LAB_ORDER.LAB_STATUS.RECEIVE_LAB')
        else if (status === 'RECEIVE_BILL') label = t('LAB_ORDER.LAB_STATUS.RECEIVE_BILL')
        else if (status === 'REPLY_LAB') label = t('LAB_ORDER.LAB_STATUS.REPLY_LAB')
        else if (status === 'CANCEL_LAB') label = t('LAB_ORDER.LAB_STATUS.CANCEL_LAB')
        else if (status === 'CLOSE_LAB') label = t('LAB_ORDER.LAB_STATUS.CLOSE_LAB')
        return label
    }

    const onReceive = (objData: LabOrderListInterface) => {
        const { labOrderId: id, labOrderNumber, dateReceive: dateRe, labOrderStatus: status } = objData
        if (status === 'RECEIVE_BILL') {
            notiError('LAB_ORDER.MESSAGE.ERROR.RECEIVE_BILL')
            return false
        }
        setLabOrderId(id)
        setDateReceive(dateRe)
        setPopupReject(false)
        dispatch(showModal())
        setPopupReceive(true)
    }

    const renderData = (objData: LabOrderListInterface, no: number) => {
        no = page * pageLimit - pageLimit + no + 1
        const { labOrderId: id, dateOrder, timeOrder, labOrderNumber: labOrderNumberList, labCompanyName, dateExport, dateImport, dateBill, cnNumber, branchCnNumber, snCode, patientFullName, labOrderPrice, labOrderStatus, updatedBy, updatedAt, doctorFullName } = objData

        const receiveLab = labOrderStatus === 'ORDER_LAB' || labOrderStatus === 'RECEIVE_LAB' || labOrderStatus === 'REPLY_LAB' ? [
            {
                option: 'COMPONANT',
                label: (
                    <DropdownItem onClick={() => onReceive(objData)} disabled={permissions.isUpdate.disabled}>
                        <span className="ml-2 align-text-bottom">{t('LAB_ORDER.QUEUE.RECEIVE_LABS')}</span>
                    </DropdownItem>
                )
            },
            { option: 'DIVIDER', label: '', disabled: false },
        ] : []

        const objRenderData = {
            key: String(no),
            id: String(id),
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: no },
                { option: 'TEXT', align: 'center', label: dateTimeToView(`${dateOrder} ${timeOrder}`, false) || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'center', label: labOrderNumberList || '-', class: 'text-nowrap-ellipsis ' },
                { option: 'TEXT', align: 'left', label: labCompanyName || '-', class: 'text-nowrap-ellipsis labCompanyName' },
                { option: 'TEXT', align: 'center', label: dateToView(dateExport, false) || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'center', label: dateToView(dateImport, false) || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'left', label: cnNumber || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'left', label: branchCnNumber || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'left', label: snCode || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'left', label: patientFullName || '-', class: 'text-nowrap-ellipsis patientFullName' },
                { option: 'TEXT', align: 'left', label: doctorFullName || '-', class: 'text-nowrap-ellipsis ' },
                { option: 'TEXT', align: 'center', label: getLabelLabOrderStatus(labOrderStatus) || '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'center', label: dateBill !== null ? dateToView(dateBill, false) : '-', class: 'text-nowrap-ellipsis' },
                { option: 'TEXT', align: 'right', label: numberToCurrencyFormat(labOrderPrice || 0), class: 'text-nowrap-ellipsis' },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy, updatedAt } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    newIconAction: true,
                    values: [
                        ...receiveLab,
                        {
                            option: 'COMPONANT', label: (
                                <DropdownItem onClick={() => onReject(objData)} disabled={permissions.isUpdate.disabled || !['ORDER_LAB', 'SEND_LAB', 'RECEIVE_LAB', 'CLOSE_LAB'].includes(labOrderStatus)}>
                                    <span className="ml-2 align-text-bottom">{t('LAB_ORDER.LAB_STATUS.BOUNCE_LAB')}</span>
                                </DropdownItem>
                            )
                        },
                        {
                            option: 'COMPONANT', label: (
                                <DropdownItem onClick={() => reset(objData)} disabled={permissions.isUpdate.disabled || labOrderStatus !== 'CANCEL_LAB'} >
                                    <span className="ml-2 align-text-bottom">{t('LAB_ORDER.LAB_STATUS.RESET_LAB')}</span>
                                </DropdownItem >
                            )
                        },
                        {
                            option: 'COMPONANT', label: (
                                <DropdownItem onClick={() => onCancel(objData)} disabled={permissions.isUpdate.disabled || labOrderStatus === 'CANCEL_LAB'} >
                                    <span className="ml-2 align-text-bottom">{t('LAB_ORDER.LAB_STATUS.CANCEL_LAB')}</span>
                                </DropdownItem >
                            )
                        },
                        { option: 'DIVIDER', label: '', disabled: false },
                        {
                            option: 'COMPONANT', label: (
                                <DropdownItem onClick={() => onViewHistory(objData)} disabled={permissions.isUpdate.disabled}>
                                    <span className="ml-2 align-text-bottom">{t('LAB_ORDER.LAB_STATUS.VIEW_HISTORY_LAB')}</span>
                                </DropdownItem>
                            )
                        },
                        {
                            option: 'COMPONANT', label: (
                                <DropdownItem onClick={() => onPrintLabDoc(objData.labOrderId)} disabled={permissions.isUpdate.disabled}>
                                    <span className="ml-2 align-text-bottom">{t('LAB_ORDER.LAB_STATUS.PRINT_LAB')}</span>
                                </DropdownItem>
                            )
                        },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'VIEW', label: t(`BUTTON.VIEW`) },
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled || labOrderStatus !== 'ORDER_LAB' },
                        { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled || labOrderStatus !== 'ORDER_LAB' }
                    ]
                },
            ]
        }
        if (!snType) {
            objRenderData.columns.splice(8, 1)
        }
        return <TableRowCommon  {...objRenderData} onView={() => onView(null, objData)} onedit={() => onEdit(objData)} ondelete={() => onDelete(objData)} />
    }

    const renderDataSlim = (objData: LabOrderListInterface, no: number) => {
        no = page * pageLimit - pageLimit + no + 1
        const { dateOrder, timeOrder, labOrderNumber: labOrderNumberList, labCompanyName, dateExport, dateImport, dateBill, cnNumber, branchCnNumber, snCode, patientFullName, labOrderPrice, labOrderStatus, updatedBy } = objData
        return (
            <UseStyled.TBody>
                <div className={'d-flex align-items-center position-relative'}>
                    <UseStyled.Cell>
                        <Grid container sx={{ pl: '24px', mx: 0 }}>
                            <div className="position-absolute w-auto px-0" style={{ marginLeft: '-1.5rem' }}>
                                {no}
                            </div>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.DATE_TIME_ORDER')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={3} sx={{ px: '4px' }}>{dateTimeToView(`${dateOrder} ${timeOrder}`)}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.LAB_ORDER_NUMBER')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={3} sx={{ px: '4px' }}><span style={{ cursor: 'pointer', color: colors.themeSecondColor, textDecoration: 'underline' }} onClick={(e: any) => onView(e, objData)}>{labOrderNumberList}</span></Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.COMPANY')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={9} sx={{ px: '4px' }}>{labCompanyName}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.DATE_EXPORT')}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} sx={{ px: '4px' }}>{dateToView(dateExport) || '-'}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.DATE_RECEIVE')}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} sx={{ px: '4px' }}>{dateToView(dateImport) || '-'}</Grid>

                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('APPLICATION.TABLE.CELL.CN_NUMBER')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={9} sx={{ px: '4px' }}>{cnNumber || '-'}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={9} sx={{ px: '4px' }}>{branchCnNumber || '-'}</Grid>


                            {snType && (
                                <>
                                    <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('PATIENT_MANAGEMENT.TABLE.CELL.SN_CODE')}</Grid>
                                    <Grid item xs={6} md={9} lg={6} xl={9} sx={{ px: '4px' }}>{snCode || '-'}</Grid>
                                </>
                            )}
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.PATIENT_NAME')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={9} sx={{ px: '4px' }}>{patientFullName || ''}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.STATUS')}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} sx={{ px: '4px' }}>{getLabelLabOrderStatus(labOrderStatus) || ''}</Grid>

                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.DATE_BILL')}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} sx={{ px: '4px' }}>{dateBill !== null ? dateToView(dateBill) : '-'}</Grid>

                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.PRICE')}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} sx={{ px: '4px' }}>{numberToCurrencyFormat(labOrderPrice || 0)}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.SAVED_BY')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={3} className="text-nowrap-ellipsis" sx={{ px: '4px' }}>{updatedBy}</Grid>
                            <Grid item xs={6} md={3} lg={6} xl={3} className="fontweght-bold" sx={{ px: '4px' }}>{t('LAB_ORDER.TABLE.ACTION')}</Grid>
                            <Grid item xs={6} md={9} lg={6} xl={3} className="text-nowrap-ellipsis" sx={{ px: '4px' }}>
                                <IconDropdownButton
                                    options={[
                                        ...(labOrderStatus === 'ORDER_LAB' || labOrderStatus === 'RECEIVE_LAB'
                                            ? [{ label: t('LAB_ORDER.QUEUE.RECEIVE_LABS'), onClick: () => onReceive(objData), disabled: permissions.isUpdate.disabled }]
                                            : []),
                                        { label: t('LAB_ORDER.LAB_STATUS.RESET_LAB'), onClick: () => onCancel(objData), disabled: permissions.isUpdate.disabled },
                                        { label: t('LAB_ORDER.LAB_STATUS.VIEW_HISTORY_LAB'), onClick: () => onViewHistory(objData), disabled: permissions.isUpdate.disabled },
                                        { label: t('LAB_ORDER.LAB_STATUS.PRINT_LAB'), onClick: () => onPrintLabDoc(objData.labOrderId), disabled: permissions.isUpdate.disabled },
                                        { label: t('BUTTON.VIEW'), icon: <VisibilityIcon className="align-text-bottom" sx={{ color: `${colors.textPrimary} !important`, fontSize: '18px' }} />, onClick: () => onView(null, objData) },
                                        { label: t(`BUTTON.EDIT`), icon: <img src={icons.dropdownEdit} alt="" className="align-baseline" />, onClick: () => onEdit(objData), disabled: permissions.isUpdate.disabled || labOrderStatus !== 'ORDER_LAB' },
                                        { label: t(`BUTTON.DELETE`), icon: <img src={icons.dropdownTrash} alt="" className="align-baseline" />, onClick: () => onDelete(objData), disabled: permissions.isUpdate.disabled || labOrderStatus !== 'ORDER_LAB' },
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </UseStyled.Cell>
                </div>
            </UseStyled.TBody>
        )
    }

    useEffect(() => { if (!modal) onReset() }, [modal]);

    return (
        <>
            <Loading show={loading} type="fullLoading" />
            <UseStyled.TableConfig expiredAlert={expire} className="h-100 d-flex flex-column overflow-hidden">
                <div className="px-3 py-2 -sticky-top" style={{ boxShadow: `0px 3px 6px ${colors.black08}`, zIndex: 0 }}>
                    <h5>{t('LAB_ORDER.HEADER')}</h5>
                </div>
                <div className='p-sm-2 p-xxl-3 h-100 d-flex flex-column overflow-hidden'>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={4} className='w-100'>
                            <TextInput
                                fullWidth
                                label={t('LAB_ORDER.LIST.SEARCH')}
                                value={filterSearch}
                                onChange={(event) => {
                                    setFilterSearch(event.target.value)
                                    setPage(1)
                                }}
                                inputProps={{
                                    endAdornment: (
                                        <Box>
                                            {filterSearch ? <FontAwesomeIcon icon={faTimes} style={{ cursor: 'pointer' }} onClick={() => {
                                                setPage(1)
                                                setFilterSearch('')
                                            }} /> : null}
                                        </Box>

                                    )
                                }}
                            />
                            {/* <InputTextSearch
                                keyInput={'search'}
                                label={t('LAB_ORDER.LIST.SEARCH')}
                                value={filterSearch}
                                onchange={(event) => {
                                    setFilterSearch(event.target.value)
                                    setPage(1)
                                }}
                                onClear={(event) => {
                                    setFilterSearch('')
                                    setPage(1)
                                }} /> */}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className='w-100'>
                            <SelectInput
                                label={t('LAB_ORDER.LIST.COMPANY')}
                                value={filterLabCompany}
                                onChange={(event) => {
                                    setFilterLabCompany(event.target.value)
                                    setPage(1)
                                }}
                                options={[{ value: 0, name: t('ALL') }, ..._.map(labCompanyOptions, (labCompany: any) => ({ value: labCompany.labCompanyId, name: labCompany.labCompanyName }))]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className='w-100'>
                            <SelectInput
                                label={t('LAB_ORDER.LIST.STATUS')}
                                value={filterLabOrderStatus}
                                onChange={(event) => {
                                    setFilterLabOrderStatus(event.target.value)
                                    setPage(1)
                                }}
                                options={[{ value: 'ALL', name: t('ALL') }, ..._.map(arrayLabOrderStatus, (statusLab: any) => ({ value: statusLab, name: getLabelLabOrderStatus(statusLab) }))]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className='w-100'>
                            <InputSecondNewRangePicker
                                value={filterRangeDate || []}
                                inputHeight={40}
                                onchange={(val: any) => {
                                    if (_.isEmpty(val)) setFilterRangeDate(emptyRangePicker)
                                    else {
                                        if (val[0] && val[1]) {
                                            setFilterRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                                            setPage(1)
                                        }
                                    }
                                }}
                                allowClear
                                onClear={() => setFilterRangeDate(emptyRangePicker)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} className='w-100'>
                            <SelectInput
                                label={t('LAB_ORDER.TABLE.DOCTOR_NAME')}
                                value={filterDoctorId}
                                onChange={(event) => {
                                    setFilterDoctorId(event.target.value)
                                    setPage(1)
                                }}
                                options={[{ value: 0, name: t('ALL') }, ..._.map(doctorOptions, (item: any) => ({ value: item.userId, name: item?.fullname }))]}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} xl={4} className='w-100'>
                            <MainButton type='primary' variant='contained' disabled={permissions.isCreate.disabled} onClick={onCreate} title={t('LAB_ORDER.LIST.ADD_LAB')} startIcon={<AddCircleIcon />} />
                        </Grid>
                    </Grid>
                    <Box className="table-list custom-scroll overflow-auto mt-2" >
                        {width >= 1441 ? (
                            <TableCustom
                                page={page}
                                pageLimit={pageLimit}
                                sortType={sortType}
                                sortBy={sortBy}
                                rowCount={rowCount}
                                onSort={(sortByVal: string, sortTypeVal: string) => {
                                    setSortType(sortTypeVal)
                                    setSortBy(sortByVal)
                                }}
                                setPageLimit={setPageLimit}
                                setPage={setPage}
                                headCells={headCells}
                                rowsData={_.map(labOrders, renderData)}
                            />
                        ) : (
                            <>
                                <UseStyled.THead>
                                    <UseStyled.Cell>{t('#')}</UseStyled.Cell>
                                </UseStyled.THead>
                                <div className={'treatment-body'}>
                                    {_.map(labOrders, renderDataSlim)}
                                    <div className={'mt-0 '}>
                                        <TablePaginationMiniCustom
                                            count={rowCount || 0}
                                            page={page}
                                            rowsPerPage={pageLimit}
                                            rowCount={rowCount}
                                            pageLimit={pageLimit}
                                            headCells={headCells}
                                            onPageChange={(event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => setPage(newPage)}
                                            setPageLimit={(event: any) => {
                                                setPageLimit(parseInt(event.target.value, 10))
                                                setPage(1)
                                            }}
                                            setPage={setPage}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </Box>
                    {isViewDetail && <ViewLabOrder labOrderId={labOrderId} showPopup={isViewDetail} onClose={onClose} />}
                    {isForm &&
                        <FormLabOrder
                            showForm={isForm}
                            labOrderId={labOrderId}
                            onReset={onReset}
                            handleSuccess={loadData}
                            onSuccess={() => props.reload && props.reload()}
                        />
                    }
                    {popupCancel && <CancelLabOrder isShow={popupCancel} labOrderNumber={labOrderNumber} id={labOrderId} onReset={onReset} onSuccess={loadData} />}
                    {popupReject &&
                        <RejectLabOrder
                            showForm={popupReject}
                            patientId={patientId}
                            labOrderNumber={labOrderNumber}
                            labOrderId={labOrderId}
                            handleSuccess={loadData}
                            onReset={setPopupReject}
                            labOrderStatus={labOrderStatus}
                        />
                    }
                </div>
            </UseStyled.TableConfig>
            {popupReceive && <ReceiveLab isShow={popupReceive} id={labOrderId} dateReceive={dateReceive} onSuccess={() => props.reloadQueue && props.reloadQueue(true)} onReset={onReset} />}

            <>
                <FunctionPrint
                    content={() => pdfLabOrderRef.current}
                    docTitle={t('TX_INFORMATION.TITLE')}
                    removeIfram
                    trigger={() => <div ref={buttonRef} className={`d-none`}>print</div>}
                    style={'@page { size: 595px 420px;  margin: 0cm;  } @media print { body { -webkit-print-color-adjust: exact; } '}
                />
                <div id="print-table-container" ref={pdfLabOrderRef} className="h-100 w-100">
                    <PDFLabOrder dataLabOrder={pdfDataLabOrder} />
                </div>
            </>

        </>
    )
}

